<!-- src/views/pages/applications/email-reply.vue -->
<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content p-0">
      <div class="d-md-flex">
        <!-- =========================
             LEFT SIDEBAR
        ========================== -->
        <div class="email-sidebar border-end border-bottom">
          <div class="active slimscroll h-100">
            <div class="slimscroll-active-sidebar">
              <div class="p-3">
                <!-- Profile (dynamic) -->
                <div class="shadow-md bg-white rounded p-2 mb-4">
                  <div class="d-flex align-items-center">
                    <a
                      href="javascript:void(0);"
                      class="avatar avatar-md flex-shrink-0 me-2"
                    >
                      <img
                        v-if="currentUser.avatar"
                        :src="currentUser.avatar"
                        class="rounded-circle"
                        alt=""
                      />
                      <span
                        v-else
                        class="avatar-title rounded-circle bg-primary text-white"
                      >
                        {{ initials(currentUser.name || "NA") }}
                      </span>
                    </a>
                    <div class="flex-fill">
                      <h6 class="mb-1">
                        <a href="javascript:void(0);">
                          {{ currentUser.name || "—" }}
                        </a>
                      </h6>
                      <p class="mb-0 text-truncate">
                        {{ currentUser.email || "—" }}
                      </p>
                    </div>
                  </div>
                </div>

                <a
                  href="javascript:void(0);"
                  class="btn btn-primary w-100"
                  @click="goBack"
                >
                  <i class="ti ti-arrow-left me-2"></i>Back to Emails
                </a>

                <!-- folders (UI only here) -->
                <div class="mt-4">
                  <h5 class="mb-2">Emails</h5>
                  <div class="d-block mb-4 pb-4 border-bottom email-tags">
                    <a
                      class="d-flex align-items-center justify-content-between p-2 rounded"
                    >
                      <span class="d-flex align-items-center fw-medium">
                        <i class="ti ti-inbox text-gray me-2"></i>Inbox
                      </span>
                      <span class="badge badge-danger rounded-pill badge-xs">
                        {{ emailStore.counts.inbox.unread }}
                      </span>
                    </a>
                    <a
                      class="d-flex align-items-center justify-content-between p-2 rounded"
                    >
                      <span class="d-flex align-items-center fw-medium">
                        <i class="ti ti-rocket text-gray me-2"></i>Sent
                      </span>
                      <span class="badge text-gray rounded-pill">
                        {{ emailStore.counts.sent.total }}
                      </span>
                    </a>
                    <a
                      class="d-flex align-items-center justify-content-between p-2 rounded"
                    >
                      <span class="d-flex align-items-center fw-medium">
                        <i class="ti ti-file text-gray me-2"></i>Drafts
                      </span>
                      <span class="badge text-gray rounded-pill">
                        {{ emailStore.counts.drafts.total }}
                      </span>
                    </a>
                    <a
                      class="d-flex align-items-center justify-content-between p-2 rounded"
                    >
                      <span class="d-flex align-items-center fw-medium">
                        <i class="ti ti-trash text-gray me-2"></i>Deleted
                      </span>
                      <span class="badge text-gray rounded-pill">
                        {{ emailStore.counts.trash.total }}
                      </span>
                    </a>
                  </div>
                </div>

                <!-- labels -->
                <div class="border-bottom mb-4 pb-4">
                  <div
                    class="d-flex align-items-center justify-content-between mb-2"
                  >
                    <h5 class="mb-0">Labels</h5>
                    <a href="javascript:void(0);">
                      <i
                        class="ti ti-square-rounded-plus-filled text-primary fs-16"
                      ></i>
                    </a>
                  </div>

                  <div v-if="emailStore.loadingLabels" class="text-muted small">
                    Loading labels...
                  </div>
                  <div v-else>
                    <a
                      v-for="l in emailStore.labels"
                      :key="l.id"
                      href="javascript:void(0);"
                      class="fw-medium d-flex align-items-center text-dark py-1"
                    >
                      <i
                        class="ti ti-square-rounded me-2"
                        :style="{ color: l.color || '#6c757d' }"
                      ></i>
                      {{ l.name }}
                    </a>
                  </div>
                </div>

                <!-- kept banner -->
                <div class="bg-dark rounded text-center position-relative p-4">
                  <span class="avatar avatar-lg rounded-circle bg-white mb-2">
                    <i class="ti ti-alert-triangle text-dark"></i>
                  </span>
                  <h6 class="text-white mb-3">
                    Enjoy Unlimited Access on a small price monthly.
                  </h6>
                  <a href="javascript:void(0);" class="btn btn-white">
                    Upgrade Now <i class="ti ti-arrow-right"></i>
                  </a>
                  <div class="box-bg">
                    <span class="bg-right">
                      <img src="@/assets/img/bg/email-bg-01.png" alt="" />
                    </span>
                    <span class="bg-left">
                      <img src="@/assets/img/bg/email-bg-02.png" alt="" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- =========================
             RIGHT: EMAIL DETAIL + THREAD
        ========================== -->
        <div class="mail-detail bg-white border-bottom p-3">
          <div class="active slimscroll h-100">
            <div class="slimscroll-active-sidebar">
              <!-- Top toolbar -->
              <div
                class="d-flex align-items-center justify-content-between flex-wrap row-gap-2 border-bottom mb-3 pb-3"
              >
                <div class="dropdown">
                  <button
                    class="btn btn-white border dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <span class="badge badge-dark rounded-circle badge-xs me-1">
                      {{ threadCount }}
                    </span>
                    Thread
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end p-3">
                    <li v-for="(m, idx) in threadMessages" :key="m.id || idx">
                      <a
                        class="dropdown-item rounded-1"
                        href="javascript:void(0);"
                      >
                        {{ m.sender?.name || "Unknown" }}
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="d-flex align-items-center gap-2">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-icon btn-sm rounded-circle"
                    title="Back"
                    @click="goBack"
                  >
                    <i class="ti ti-arrow-back-up"></i>
                  </a>

                  <a
                    href="javascript:void(0);"
                    class="btn btn-icon btn-sm rounded-circle"
                    title="Delete"
                    @click="onDeleteEmail"
                    :class="{ disabled: !emailId }"
                  >
                    <i class="ti ti-trash"></i>
                  </a>

                  <a
                    href="javascript:void(0);"
                    class="btn btn-icon btn-sm rounded-circle"
                    title="Mark unread"
                    @click="toggleRead(false)"
                    :class="{ disabled: isDraft }"
                  >
                    <i class="ti ti-mail-opened"></i>
                  </a>

                  <a
                    href="javascript:void(0);"
                    class="btn btn-icon btn-sm rounded-circle"
                    title="Mark read"
                    @click="toggleRead(true)"
                    :class="{ disabled: isDraft }"
                  >
                    <i class="ti ti-mail-opened-filled"></i>
                  </a>

                  <a
                    href="javascript:void(0);"
                    class="btn btn-icon btn-sm rounded-circle"
                    title="Refresh"
                    @click="reload"
                  >
                    <i class="ti ti-refresh"></i>
                  </a>
                </div>
              </div>

              <!-- Loading / Empty -->
              <div v-if="loadingEmail" class="p-3 text-muted">
                Loading email...
              </div>
              <div v-else-if="!email" class="p-3 text-muted">
                Email not found.
              </div>

              <!-- Email header summary -->
              <div v-else class="bg-light-500 rounded p-3 mb-3">
                <div
                  class="d-flex align-items-center flex-fill border-bottom mb-3 pb-3"
                >
                  <a
                    href="javascript:void(0);"
                    class="avatar avatar-md avatar-rounded flex-shrink-0 me-2"
                  >
                    <img
                      v-if="email.sender?.avatar"
                      :src="email.sender.avatar"
                      alt=""
                    />
                    <span v-else class="avatar-title">
                      {{ initials(email.sender?.name || "NA") }}
                    </span>
                  </a>

                  <div class="flex-fill">
                    <div
                      class="d-flex align-items-start justify-content-between flex-wrap row-gap-2"
                    >
                      <div>
                        <h6 class="mb-1">
                          <a href="javascript:void(0);">{{
                            email.sender?.name || "Unknown Sender"
                          }}</a>
                        </h6>

                        <p class="mb-0">
                          Subject:
                          <span class="fw-medium">{{
                            email.subject || "No Subject"
                          }}</span>
                        </p>

                        <div
                          v-if="email.labels?.length"
                          class="mt-2 d-flex flex-wrap gap-2"
                        >
                          <span
                            v-for="l in email.labels"
                            :key="l.id"
                            class="badge"
                            :style="labelPillStyle(l)"
                          >
                            <i class="ti ti-square me-1"></i>{{ l.name }}
                          </span>
                        </div>
                      </div>

                      <div class="d-flex align-items-center">
                        <p class="me-2 mb-0">
                          {{ formatDateTime(email.created_at) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center flex-wrap row-gap-2">
                  <p class="fs-12 mb-0 text-dark me-3">
                    <span class="text-gray">From: </span
                    >{{ email.sender?.email || "—" }}
                  </p>
                  <p class="fs-12 mb-0 text-dark me-3">
                    <span class="text-gray">To: </span>{{ toLine }}
                  </p>
                  <p class="fs-12 mb-0 text-dark" v-if="ccLine">
                    <span class="text-gray">Cc: </span>{{ ccLine }}
                  </p>
                </div>
              </div>

              <!-- =========================
                   DRAFT EDITOR (when draft)
              ========================== -->
              <div v-if="email && isDraft" class="card shadow-none">
                <div class="card-body">
                  <div
                    class="d-flex align-items-center justify-content-between mb-2"
                  >
                    <h6 class="mb-0">Draft</h6>
                    <small class="text-muted">
                      {{
                        emailStore.draftSaving
                          ? "Saving..."
                          : draftSavedText || ""
                      }}
                    </small>
                  </div>

                  <form @submit.prevent="sendDraftNow">
                    <div class="mb-3">
                      <label class="form-label">To (comma separated)</label>
                      <input
                        v-model.trim="draftTo"
                        class="form-control"
                        placeholder="john@company.com, jane@company.com"
                        @input="scheduleDraftAutosave"
                      />
                    </div>

                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <label class="form-label">Cc</label>
                        <input
                          v-model.trim="draftCc"
                          class="form-control"
                          placeholder="cc@company.com"
                          @input="scheduleDraftAutosave"
                        />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">Bcc</label>
                        <input
                          v-model.trim="draftBcc"
                          class="form-control"
                          placeholder="bcc@company.com"
                          @input="scheduleDraftAutosave"
                        />
                      </div>
                    </div>

                    <div class="mb-3">
                      <label class="form-label">Subject</label>
                      <input
                        v-model="draftSubject"
                        type="text"
                        class="form-control"
                        placeholder="Subject"
                        @input="scheduleDraftAutosave"
                      />
                    </div>

                    <div class="mb-0">
                      <label class="form-label">Message</label>
                      <textarea
                        v-model="draftBody"
                        rows="7"
                        class="form-control"
                        placeholder="Compose Email"
                        @input="scheduleDraftAutosave"
                      ></textarea>
                    </div>

                    <!-- Attachments (same buffer) -->
                    <div v-if="emailStore.attachments.length" class="mt-3">
                      <div
                        class="d-flex align-items-center justify-content-between mb-2"
                      >
                        <small class="text-muted">Attachments</small>
                        <small
                          v-if="emailStore.attachmentsUploading"
                          class="text-muted"
                          >Uploading...</small
                        >
                      </div>

                      <div class="d-flex flex-wrap gap-2">
                        <div
                          v-for="a in emailStore.attachments"
                          :key="a.id"
                          class="badge bg-light text-dark border d-flex align-items-center gap-2"
                        >
                          <span class="text-truncate" style="max-width: 260px">
                            {{ a.original_name }}
                          </span>

                          <a
                            v-if="a.is_previewable"
                            href="javascript:void(0);"
                            @click="openPreview(a)"
                          >
                            <i class="ti ti-eye"></i>
                          </a>

                          <a
                            href="javascript:void(0);"
                            @click="emailStore.downloadAttachment(a)"
                          >
                            <i class="ti ti-download"></i>
                          </a>

                          <a
                            href="javascript:void(0);"
                            @click="emailStore.deleteComposeAttachment(a.id)"
                          >
                            <i class="ti ti-x"></i>
                          </a>
                        </div>
                      </div>
                    </div>

                    <input
                      ref="draftFileInput"
                      type="file"
                      multiple
                      class="d-none"
                      @change="onDraftFilesPicked"
                    />

                    <div
                      class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"
                    >
                      <a
                        href="javascript:void(0);"
                        class="btn btn-light btn-sm d-inline-flex align-items-center"
                        @click="pickDraftFiles"
                      >
                        <i class="ti ti-paperclip me-2"></i>Attach
                      </a>

                      <div class="d-flex align-items-center gap-2">
                        <button
                          type="button"
                          class="btn btn-white btn-sm"
                          :disabled="emailStore.draftSaving"
                          @click="saveDraftNow"
                        >
                          <i class="ti ti-device-floppy me-2"></i>Save
                        </button>

                        <button
                          type="submit"
                          class="btn btn-primary btn-sm d-inline-flex align-items-center"
                          :disabled="emailStore.sending"
                        >
                          <span v-if="!emailStore.sending">
                            Send <i class="ti ti-arrow-right ms-2"></i>
                          </span>
                          <span v-else>Sending...</span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <!-- =========================
                   THREAD (messages)
              ========================== -->
              <div v-if="email && !isDraft" class="card shadow-none">
                <div class="card-body">
                  <div
                    v-for="(m, idx) in threadMessages"
                    :key="m.id || idx"
                    class="mb-4"
                  >
                    <div class="bg-light-500 rounded p-3 mb-3">
                      <div
                        class="d-flex align-items-center flex-wrap row-gap-2 flex-fill"
                      >
                        <a
                          href="javascript:void(0);"
                          class="avatar avatar-md avatar-rounded flex-shrink-0 me-2"
                        >
                          <img
                            v-if="m.sender?.avatar"
                            :src="m.sender.avatar"
                            alt=""
                          />
                          <span v-else class="avatar-title">{{
                            initials(m.sender?.name || "NA")
                          }}</span>
                        </a>

                        <div class="flex-fill">
                          <div
                            class="d-flex align-items-start justify-content-between flex-wrap row-gap-2"
                          >
                            <div>
                              <h6 class="mb-1">
                                <a href="javascript:void(0);">{{
                                  m.sender?.name || "Unknown"
                                }}</a>
                              </h6>
                              <div class="d-flex align-items-center">
                                <p class="mb-0">
                                  <span class="text-gray">To:</span> Me
                                </p>
                              </div>
                            </div>

                            <div class="d-flex align-items-center">
                              <p class="me-2 mb-0">
                                {{ formatDateTime(m.created_at) }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="m.body_html"
                      class="text-dark"
                      v-html="m.body_html"
                    ></div>
                    <div v-else class="text-dark" style="white-space: pre-wrap">
                      {{ m.body_text || "" }}
                    </div>

                    <div v-if="(m.attachments || []).length" class="mt-3">
                      <div
                        class="d-flex align-items-center justify-content-between my-2 pt-2 border-top"
                      >
                        <h6 class="mb-0">Attachments</h6>
                      </div>

                      <div class="d-flex flex-wrap gap-2">
                        <div
                          v-for="a in m.attachments"
                          :key="a.id"
                          class="badge bg-light text-dark border d-flex align-items-center gap-2"
                        >
                          <span
                            class="text-truncate"
                            style="max-width: 260px"
                            >{{ a.original_name }}</span
                          >

                          <a
                            v-if="a.is_previewable"
                            href="javascript:void(0);"
                            @click="openPreview(a)"
                          >
                            <i class="ti ti-eye"></i>
                          </a>

                          <a
                            href="javascript:void(0);"
                            @click="emailStore.downloadAttachment(a)"
                          >
                            <i class="ti ti-download"></i>
                          </a>
                        </div>
                      </div>
                    </div>

                    <hr v-if="idx < threadMessages.length - 1" />
                  </div>
                </div>
              </div>

              <!-- =========================
                    REPLY BOX
              ========================== -->
              <div class="card shadow-none" v-if="email && !isDraft">
                <div class="card-body">
                  <form @submit.prevent="submitReply">
                    <div class="border rounded mt-3">
                      <div class="p-3">
                        <div class="mb-3">
                          <textarea
                            v-model="replyBody"
                            rows="4"
                            class="form-control"
                            placeholder="Write your reply..."
                          ></textarea>
                        </div>

                        <div v-if="emailStore.attachments.length" class="mt-3">
                          <div
                            class="d-flex align-items-center justify-content-between mb-2"
                          >
                            <small class="text-muted">Attachments</small>
                            <small
                              v-if="emailStore.attachmentsUploading"
                              class="text-muted"
                              >Uploading...</small
                            >
                          </div>

                          <div class="d-flex flex-wrap gap-2">
                            <div
                              v-for="a in emailStore.attachments"
                              :key="a.id"
                              class="badge bg-light text-dark border d-flex align-items-center gap-2"
                            >
                              <span
                                class="text-truncate"
                                style="max-width: 260px"
                                >{{ a.original_name }}</span
                              >

                              <a
                                v-if="a.is_previewable"
                                href="javascript:void(0);"
                                @click="openPreview(a)"
                              >
                                <i class="ti ti-eye"></i>
                              </a>

                              <a
                                href="javascript:void(0);"
                                @click="emailStore.downloadAttachment(a)"
                              >
                                <i class="ti ti-download"></i>
                              </a>

                              <a
                                href="javascript:void(0);"
                                @click="
                                  emailStore.deleteComposeAttachment(a.id)
                                "
                              >
                                <i class="ti ti-x"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="d-flex align-items-center justify-content-between border-top p-3"
                      >
                        <input
                          ref="fileInput"
                          type="file"
                          multiple
                          class="d-none"
                          @change="onFilesPicked"
                        />

                        <a
                          href="javascript:void(0);"
                          class="btn btn-light btn-sm d-inline-flex align-items-center"
                          @click="pickFiles"
                        >
                          <i class="ti ti-paperclip me-2"></i>Attach
                        </a>

                        <button
                          type="submit"
                          class="btn btn-primary d-inline-flex align-items-center ms-2"
                          :disabled="replying"
                        >
                          <span v-if="!replying"
                            >Send <i class="ti ti-arrow-right ms-2"></i
                          ></span>
                          <span v-else>Sending...</span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="text-center">
                <a href="javascript:void(0);" class="btn btn-dark btn-sm"
                  >View Older Messages</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="footer d-sm-flex align-items-center justify-content-between bg-white p-3"
      >
        <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
        <p class="mb-0">
          Powered by
          <a href="javascript:void(0);" class="text-primary"
            >DoneQuick Technological World</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { toast } from "@/utils/toast";
import { useEmailStore } from "@/stores/emailStore";

// ✅ adjust if your auth store path/name differs
import { useAuthStore } from "@/stores/authStore";

const route = useRoute();
const router = useRouter();
const emailStore = useEmailStore();
const authStore = useAuthStore();

const emailId = computed(() => route.query.email_id || route.params.id || null);

const currentUser = computed(() => {
  const u = authStore.user || {};
  return {
    name: `${u.first_name || ""} ${u.last_name || ""}`.trim() || "—",
    email: u.email || "",
    avatar: u.avatar || u.photo_url || u.logo_url || "",
  };
});

const loadingEmail = computed(() => emailStore.loadingEmail);
const email = computed(() => emailStore.activeEmail);
const replying = computed(() => emailStore.sending);

// is draft? (supports multiple backend shapes)
const isDraft = computed(() => {
  const e = email.value || {};
  return e.folder === "drafts" || e.is_draft === true || e.status === "draft";
});

const threadMessages = computed(() => {
  const msgs = email.value?.messages || [];
  return Array.isArray(msgs) ? msgs : [];
});
const threadCount = computed(() => threadMessages.value.length || 0);

const toLine = computed(() => {
  const to = email.value?.to || [];
  if (!Array.isArray(to) || to.length === 0) return "—";
  return to
    .map((x) => (typeof x === "string" ? x : x?.email || x?.name))
    .filter(Boolean)
    .join(", ");
});

const ccLine = computed(() => {
  const cc = email.value?.cc || [];
  if (!Array.isArray(cc) || cc.length === 0) return "";
  return cc
    .map((x) => (typeof x === "string" ? x : x?.email || x?.name))
    .filter(Boolean)
    .join(", ");
});

function goBack() {
  router.push("/applications/email");
}

async function reload() {
  if (!emailId.value) return;
  // drafts should not be auto-marked read
  await emailStore.fetchEmail(emailId.value, { markRead: !isDraft.value });
}

async function toggleRead(read) {
  if (!emailId.value) return;
  if (isDraft.value) return; // don't apply read flags to drafts
  await emailStore.markRead(emailId.value, !!read);
  if (email.value) email.value.is_read = !!read;
  toast(read ? "Marked as read" : "Marked as unread");
}

async function onDeleteEmail() {
  if (!emailId.value) return;
  if (!confirm("Delete this email?")) return;
  await emailStore.deleteEmail(emailId.value);
  goBack();
}

function initials(name) {
  const n = String(name || "").trim();
  if (!n) return "NA";
  const parts = n.split(/\s+/).filter(Boolean);
  return parts
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();
}

function formatDateTime(dt) {
  if (!dt) return "";
  try {
    return new Date(dt).toLocaleString([], {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
}

function labelPillStyle(label) {
  const c = label?.color || "#6c757d";
  return { background: `${c}20`, color: c, border: `1px solid ${c}40` };
}

/* =========================
   Reply + Attachments
========================= */
const replyBody = ref("");
const fileInput = ref(null);

function pickFiles() {
  fileInput.value?.click();
}

async function onFilesPicked(e) {
  const files = e.target.files;
  if (!files || !files.length) return;

  // unattached uploads, then passed as attachment_ids in replyToEmail
  await emailStore.uploadAttachments({ files, emailId: null });

  e.target.value = "";
}

async function openPreview(att) {
  const tempUrl = await emailStore.getPreviewUrl(att);
  window.open(tempUrl || att.url, "_blank");
}

async function submitReply() {
  if (!emailId.value) return;
  if (!replyBody.value.trim()) return toast("Type your reply first", "error");

  await emailStore.replyToEmail(emailId.value, {
    body_text: replyBody.value,
    attachment_ids: emailStore.attachments.map((a) => a.id),
  });

  emailStore.attachments = [];
  replyBody.value = "";
}

/* =========================
   Draft editing + send
========================= */
const draftTo = ref("");
const draftCc = ref("");
const draftBcc = ref("");
const draftSubject = ref("");
const draftBody = ref("");

const draftFileInput = ref(null);

function pickDraftFiles() {
  draftFileInput.value?.click();
}

async function onDraftFilesPicked(e) {
  const files = e.target.files;
  if (!files || !files.length) return;

  // if backend expects attachments linked to draft email id, pass emailId
  await emailStore.uploadAttachments({ files, emailId: emailId.value });

  e.target.value = "";
}

function parseEmails(str) {
  if (!str) return [];
  return String(str)
    .split(",")
    .map((x) => x.trim())
    .filter(Boolean);
}

function buildDraftPayload() {
  return {
    to: parseEmails(draftTo.value),
    cc: parseEmails(draftCc.value),
    bcc: parseEmails(draftBcc.value),
    subject: draftSubject.value,
    body_text: draftBody.value,
    attachment_ids: emailStore.attachments.map((a) => a.id),
  };
}

const draftSavedText = computed(() => {
  if (emailStore.draftSaving) return "Saving...";
  if (emailStore.lastDraftSavedAt) return "Saved";
  return "";
});

let autosaveTimer = null;
const isDraftDirty = ref(false);

function scheduleDraftAutosave() {
  isDraftDirty.value = true;
  if (autosaveTimer) clearTimeout(autosaveTimer);
  autosaveTimer = setTimeout(async () => {
    if (!isDraftDirty.value) return;
    await saveDraftNow();
  }, 900);
}

async function saveDraftNow() {
  if (!emailId.value) return;

  const payload = buildDraftPayload();
  const hasSomething =
    payload.to.length ||
    payload.cc.length ||
    payload.bcc.length ||
    (payload.subject || "").trim() ||
    (payload.body_text || "").trim() ||
    payload.attachment_ids.length;

  if (!hasSomething) return;

  await emailStore.updateDraft(emailId.value, payload);
  isDraftDirty.value = false;
}

async function sendDraftNow() {
  if (!emailId.value) return;

  const payload = buildDraftPayload();
  if (!payload.to.length) return toast("Add at least 1 recipient", "error");

  await emailStore.sendDraft(emailId.value, payload);
  emailStore.attachments = [];
  goBack();
}

// When the email loads, hydrate draft fields if draft
watch(
  () => email.value,
  (val) => {
    if (!val) return;

    // clear compose/reply buffer when opening a new email
    emailStore.attachments = [];

    if (isDraft.value) {
      // supports if backend stores arrays or strings
      const to = Array.isArray(val.to)
        ? val.to
            .map((x) => (typeof x === "string" ? x : x?.email))
            .filter(Boolean)
            .join(", ")
        : val.to || "";

      const cc = Array.isArray(val.cc)
        ? val.cc
            .map((x) => (typeof x === "string" ? x : x?.email))
            .filter(Boolean)
            .join(", ")
        : val.cc || "";

      const bcc = Array.isArray(val.bcc)
        ? val.bcc
            .map((x) => (typeof x === "string" ? x : x?.email))
            .filter(Boolean)
            .join(", ")
        : val.bcc || "";

      draftTo.value = to ? `${to}` : "";
      draftCc.value = cc ? `${cc}` : "";
      draftBcc.value = bcc ? `${bcc}` : "";
      draftSubject.value = val.subject || "";
      draftBody.value = val.body_text || val.body || "";
    }
  },
  { immediate: true }
);

onMounted(async () => {
  await emailStore.fetchLabels();

  if (!emailId.value) {
    toast("Missing email_id in URL", "error");
    return;
  }

  // drafts should not auto markRead
  await emailStore.fetchEmail(emailId.value, { markRead: false });
});

onBeforeUnmount(() => {
  if (autosaveTimer) clearTimeout(autosaveTimer);
  // avoid leaking attachments to other pages
  emailStore.attachments = [];
});
</script>

<style scoped>
.btn.disabled,
.btn:disabled {
  pointer-events: none;
  opacity: 0.6;
}
</style>


